// extracted by mini-css-extract-plugin
export var button = "markdown-module--button--d2a9f";
export var buttonLink = "markdown-module--button-link--b01a7";
export var markdown = "markdown-module--markdown--272c3";